import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map } from "lodash";
import { CourseItem } from "../CourseItem/CourseItem";
import { Course } from "../../../../api";
import "./ListCourses.scss";

const courseController = new Course();

export function Listcourses(props) {
  const { reload, onReload } = props;
  const [courses, setCourses] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const response = await courseController.getCourses({ page, limit: 5 }); //le envio un objeto con page y limit
        // console.log(response);
        setCourses(response.courses.docs); //esto es para que se muestren los cursos
        // console.log('response.courses.totalPages', response.courses.totalPages);
        // console.log('response.courses.page', response.courses.page);
        // console.log('response.courses.totalDocs', response.courses.totalDocs);
        //console.log('response.courses.limit', response.courses.limit);

        setPagination({
          limit: response.courses.limit,
          page: response.courses.page,
          total: response.courses.totalPages,
          totalDocs: response.courses.totalDocs,
        });
      } catch (error) {
        throw error;
      }
    })();
  }, [page, reload]); //se vuelve a ejecutarcada vez que cambie la pagina

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!courses) return <Loader active inline="centered" />; //esot hace que se muestre el loader mientras se carga la data
  if (size(courses) === 0) return <h2>No hay cursos</h2>; //esto hace que si no hay cursos muestre el mensaje
  //en caso de que si haya cursos
  //

  return (
    <div className="list-courses">
      {map(courses, (course) => (
        <CourseItem key={course._id} course={course} onReload={onReload} />
      ))}

      <div className="list-courses__pagination">
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
